[
    {
        "id": "lib-welcome-tour-link",
        "title": "Welcome with Tour Link",
        "description": "Sends new leads a direct link to book a tour as soon as they inquire.",
        "category": "welcome",
        "uses": 3318,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hey {lead_first_name}, would you like to tour {property_address} this week? Schedule your tour here! {property_tour_link}",
        "filters": ["has-property", "has-property-tour-link"]
    },
    {
        "id": "lib-welcome-simple-availability",
        "title": "Simple Availability Reply",
        "description": "Confirms the unit is available and invites the lead to pick a tour day.",
        "category": "welcome",
        "uses": 1180,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hey {lead_first_name}, the unit is still available. Are you interested in touring our community? Let me know what day works for you!"
    },
    {
        "id": "lib-welcome-quick",
        "title": "Quick Welcome",
        "description": "A short, direct welcome that asks when the lead is free to tour.",
        "category": "welcome",
        "uses": 845,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hi {lead_first_name}, this unit is available! When are you available for a tour?"
    },
    {
        "id": "lib-welcome-rental-criteria",
        "title": "Welcome with Rental Criteria",
        "description": "Shares the move-in date question alongside the key rental qualifications upfront.",
        "category": "welcome",
        "uses": 2016,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hey {lead_first_name},\n\nThe property on {property_address} is still available! What is your desired move-in date?\n\nHere's the qualifications:\n\n✓ Income has to be 3X the rent\n✓ Credit score of at least 525\n✓ No broken leases\n✓ No eviction or outstanding balances\n✓ No felonies",
        "filters": ["has-property"]
    },
    {
        "id": "lib-welcome-qualifying-questions",
        "title": "Welcome – Qualifying Questions",
        "description": "Kicks off a conversation by asking about income, occupants, pets, and reason for moving.",
        "category": "welcome",
        "uses": 2859,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hi {lead_first_name},\n\nYes it is available. We can arrange a tour. We find it helpful to learn a bit more about the prospective tenant. Can you share more about yourself?\n\n- What do you do for income?\n- How many people will be moving in?\n- Do you have any pets? If yes, breed and how many?\n- Why are you moving from your current place?\n\nThank you for answering these questions."
    },
    {
        "id": "lib-welcome-move-in-date",
        "title": "Welcome – Move-In Date",
        "description": "A concise opener that asks for the lead's desired move-in timeline.",
        "category": "welcome",
        "uses": 221,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hi {lead_first_name}, thanks for reaching out about {property_address}. When are you looking to move?",
        "filters": ["has-property"]
    },
    {
        "id": "lib-welcome-units-rent-fast",
        "title": "Welcome – Units Rent Fast",
        "description": "Creates light urgency by noting units move quickly, then asks for tour availability.",
        "category": "welcome",
        "uses": 774,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Thank you for your interest in our property at {property_address}! Our units rent quickly. When are you available for a tour?",
        "filters": ["has-property"]
    },
    {
        "id": "lib-welcome-tour-booking",
        "title": "Welcome with Tour Booking",
        "description": "Thanks the lead for reaching out and provides a direct link to book a tour.",
        "category": "welcome",
        "uses": 1112,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hi {lead_first_name}!\n\nThanks so much for reaching out about {property_address}. If you're interested in booking a tour, click here to book one: {property_tour_link}",
        "filters": ["has-property", "has-property-tour-link"]
    },
    {
        "id": "lib-followup-tour-app-links",
        "title": "Follow-Up with Tour & Application Links",
        "description": "Follows up after 2 days of no response, sharing both the tour booking and application links.",
        "category": "followup",
        "uses": 29924,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 2
            }
        },
        "message": "Hi! We are just following up about your inquiry. Please schedule a tour here if you haven't seen the place yet: {property_tour_link}. If you wish to apply, please apply using this link: {property_application_link}",
        "filters": ["has-property", "has-property-tour-link", "has-property-application-link"]
    },
    {
        "id": "lib-followup-3day-no-response",
        "title": "3-Day No Response Follow-Up",
        "description": "A friendly check-in 3 days after the last outreach to see if the lead is still searching.",
        "category": "followup",
        "uses": 12039,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 3
            }
        },
        "message": "Hi {lead_first_name},\n\nJust checking in to see if you are still looking for your next apartment.\n\nPlease let me know if I can assist!"
    },
    {
        "id": "lib-followup-24hr",
        "title": "24-Hour Follow-Up",
        "description": "A personalised next-day check-in offering to answer any questions.",
        "category": "followup",
        "uses": 5421,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 1
            }
        },
        "message": "Hello, {lead_first_name}, this is {your_first_name}. I am just checking in to see if you are still interested in leasing with us? I can answer any questions you may have!"
    },
    {
        "id": "lib-followup-2day-property",
        "title": "2-Day Property Follow-Up",
        "description": "Checks in after 2 days and keeps the conversation tied to the specific property.",
        "category": "followup",
        "uses": 4783,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 2
            }
        },
        "message": "Hey {lead_first_name}, just checking in to see if you are still interested in renting {property_address}. Please let us know if you have any questions or concerns!",
        "filters": ["has-property"]
    },
    {
        "id": "lib-followup-quick-checkin",
        "title": "Quick Check-In",
        "description": "A two-sentence check-in asking if the lead is still interested.",
        "category": "followup",
        "uses": 2441,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 2
            }
        },
        "message": "Hey {lead_first_name}!\n\nWe are just checking in. Are you still interested?"
    },
    {
        "id": "lib-followup-simple-interest",
        "title": "Simple Interest Check",
        "description": "A single-line follow-up asking if the lead is still interested in the unit.",
        "category": "followup",
        "uses": 2172,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 1
            }
        },
        "message": "Hey {lead_first_name}, are you still interested in this unit?"
    },
    {
        "id": "lib-followup-minimal",
        "title": "Minimal Follow-Up",
        "description": "The shortest possible check-in — just name and a yes/no rental question.",
        "category": "followup",
        "uses": 1791,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 2
            }
        },
        "message": "{lead_first_name}, checking in. Are you still looking to rent?"
    },
    {
        "id": "lib-followup-direct",
        "title": "Direct Follow-Up",
        "description": "A blunt, conversational nudge — popular for its high open and reply rates.",
        "category": "followup",
        "uses": 1512,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 1
            }
        },
        "message": "Hey {lead_first_name}, just checking in. Have you given up on this apartment?"
    },
    {
        "id": "lib-followup-still-interested",
        "title": "Still Interested?",
        "description": "A concise follow-up after 2 days of silence — name + a simple yes/no question.",
        "category": "followup",
        "uses": 1407,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 2
            }
        },
        "message": "{lead_first_name}, are you still interested in renting?"
    },
    {
        "id": "lib-followup-gentle-reengage",
        "title": "Gentle Re-Engagement",
        "description": "A soft nudge inviting the lead to set up a tour when they're ready.",
        "category": "followup",
        "uses": 652,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 1
            }
        },
        "message": "{lead_first_name}, are you still interested? Let us know if you would like to set up a tour."
    },
    {
        "id": "lib-followup-tour-booking-link",
        "title": "Follow-Up with Tour Booking",
        "description": "Re-engages unresponsive leads after 2 days with a direct tour booking link.",
        "category": "followup",
        "uses": 272,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 2
            }
        },
        "message": "Hey {lead_first_name}, we wanted to check if you are still interested in our property. If you'd like another look or have any questions, we'd love to set up a tour.\n\nBook your tour: {property_tour_link}",
        "filters": ["has-property", "has-property-tour-link"]
    },
    {
        "id": "lib-facebook-auto-response",
        "title": "Facebook Auto-Response",
        "description": "Instantly replies to incoming Facebook messages confirming availability and asking for a tour time.",
        "category": "facebook",
        "uses": 1242,
        "trigger": {
            "type": "incoming-facebook-message",
            "run_limit_per_lead": 1
        },
        "message": "Hey {lead_first_name}, it is available. What time today or tomorrow works for you to come see it?"
    },
    {
        "id": "lib-facebook-when-to-move",
        "title": "Facebook – When to Move?",
        "description": "Responds to a new Facebook inquiry confirming availability and asking about move-in timing.",
        "category": "facebook",
        "uses": 1149,
        "trigger": {
            "type": "incoming-facebook-message",
            "run_limit_per_lead": 1
        },
        "message": "Hello {lead_first_name}. This unit is still available. When are you looking to move?"
    },
    {
        "id": "lib-confirm-day-of",
        "title": "Day-of Tour Reminder",
        "description": "Sends a same-day reminder 2 hours before a scheduled tour to confirm it's still on.",
        "category": "confirmation",
        "uses": 148,
        "trigger": {
            "type": "tour_started",
            "run_limit_per_lead": 5,
            "params": {
                "time_offset_type": "before",
                "time_offset_unit": "hours",
                "time_offset_value": 2
            }
        },
        "message": "Hi {lead_first_name}, you have a tour at {property_address} today. Does that still work?",
        "filters": ["has-property"]
    },
    {
        "id": "lib-confirm-day-before",
        "title": "Day-Before Tour Reminder",
        "description": "Sends a reminder 24 hours before a scheduled tour asking for a confirmation or reschedule.",
        "category": "confirmation",
        "uses": 115,
        "trigger": {
            "type": "tour_started",
            "run_limit_per_lead": 5,
            "params": {
                "time_offset_type": "before",
                "time_offset_unit": "hours",
                "time_offset_value": 24
            }
        },
        "message": "Hi {lead_first_name}, you have a tour at {property_address} tomorrow. Please confirm your tour with C or reschedule with R.",
        "filters": ["has-property"]
    },
    {
        "id": "lib-posttour-checkin",
        "title": "Post-Tour Check-In",
        "description": "Follows up 1 hour after a tour to ask if the lead was able to see the property.",
        "category": "post-tour",
        "uses": 471,
        "trigger": {
            "type": "tour_started",
            "run_limit_per_lead": 5,
            "params": {
                "time_offset_type": "after",
                "time_offset_unit": "hours",
                "time_offset_value": 1
            }
        },
        "message": "Hey {lead_first_name}! Were you able to tour the property?"
    },
    {
        "id": "lib-posttour-application",
        "title": "Post-Tour Application Prompt",
        "description": "Checks in after the tour and shares the application link while interest is fresh.",
        "category": "post-tour",
        "uses": 240,
        "trigger": {
            "type": "tour_started",
            "run_limit_per_lead": 5,
            "params": {
                "time_offset_type": "after",
                "time_offset_unit": "hours",
                "time_offset_value": 1
            }
        },
        "message": "Hi {lead_first_name}, were you able to tour {property_address} today?\n\nIf you want to apply, here is the link: {property_application_link}",
        "filters": ["has-property", "has-property-application-link"]
    },
    {
        "id": "lib-welcome-tour-app-links",
        "title": "Welcome with Tour & Application Links",
        "description": "Greets a new lead, confirms immediate availability, and shares both the tour booking and application links in one message.",
        "category": "welcome",
        "uses": 1800,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Thanks for your interest in {property_address}! The home is available for immediate move-in.\n\nSchedule a tour: {property_tour_link}\n\nStart your application: {property_application_link}",
        "filters": ["has-property", "has-property-tour-link", "has-property-application-link"]
    },
    {
        "id": "lib-welcome-thank-you-move-date",
        "title": "Welcome – Thank You & Move-In Date",
        "description": "A polished, brand-neutral opener that thanks the lead and asks for their move-in timeline — no property address variable required.",
        "category": "welcome",
        "uses": 495,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hi {lead_first_name}, thank you for your interest in our property. When are you looking to move?"
    },
    {
        "id": "lib-welcome-waitlist",
        "title": "Welcome – No Vacancy Waitlist",
        "description": "Sends when no unit is currently available, offering to add the lead to an interest list for future openings.",
        "category": "welcome",
        "uses": 106,
        "trigger": {
            "type": "lead_ingested",
            "run_limit_per_lead": 1
        },
        "message": "Hey {lead_first_name}, we appreciate your interest in our property. We do not have any vacancy at this time. Would you like to be added to our interest list?"
    },
    {
        "id": "lib-followup-7day",
        "title": "7-Day Re-Engagement",
        "description": "Reaches back out after a full week of silence to see if the lead is still in the market.",
        "category": "followup",
        "uses": 1500,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 7
            }
        },
        "message": "Hi {lead_first_name}, just checking back in — are you still looking for a rental? Let us know what you need and we would be happy to help."
    },
    {
        "id": "lib-followup-5day-casual",
        "title": "5-Day Casual Follow-Up",
        "description": "A low-pressure nudge after 5 days of silence, reminding the lead they can reach out with any questions.",
        "category": "followup",
        "uses": 109,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 5
            }
        },
        "message": "Hey again — just making sure you received my last message. Please let me know if you need any more info!"
    },
    {
        "id": "lib-followup-ghosting",
        "title": "Humorous Ghosting Check-In",
        "description": "A light-hearted 3-day follow-up that assumes the lead found a place, but re-opens the door if they haven't.",
        "category": "followup",
        "uses": 199,
        "trigger": {
            "type": "lead_unresponsive",
            "run_limit_per_lead": 1,
            "params": {
                "time_unit": "days",
                "time_value": 3
            }
        },
        "message": "I'm guessing you found a place already! But if not, our unit is still available. Let us know — we would love to help you find the right fit."
    },
    {
        "id": "lib-facebook-criteria",
        "title": "Facebook – Availability & Rental Criteria",
        "description": "Responds to a Facebook inquiry by confirming availability, asking for the move-in date, and listing the rental qualifications upfront.",
        "category": "facebook",
        "uses": 946,
        "trigger": {
            "type": "incoming-facebook-message",
            "run_limit_per_lead": 1
        },
        "message": "Hi {lead_first_name}! The property on {property_address} is still available! What is your desired move-in date?\n\nHere are the qualifications:\n✓ Income has to be 3X the rent\n✓ Credit score of at least 525\n✓ No broken leases\n✓ No eviction or outstanding balances\n✓ No felonies",
        "filters": ["has-property"]
    },
    {
        "id": "lib-confirm-reply-1-or-2",
        "title": "Tour Confirmation – Reply 1 or 2",
        "description": "Sends a 3-hour reminder asking the lead to reply 1 to confirm their tour or 2 to reschedule.",
        "category": "confirmation",
        "uses": 83,
        "trigger": {
            "type": "tour_started",
            "run_limit_per_lead": 5,
            "params": {
                "time_offset_type": "before",
                "time_offset_unit": "hours",
                "time_offset_value": 3
            }
        },
        "message": "Hi {lead_first_name}, we have you scheduled for a tour today at {property_address}. Please reply 1 to confirm or 2 to reschedule.",
        "filters": ["has-property"]
    },
    {
        "id": "lib-posttour-feedback",
        "title": "Post-Tour Feedback Request",
        "description": "Checks in after a tour to ask for the lead's impressions of the property.",
        "category": "post-tour",
        "uses": 55,
        "trigger": {
            "type": "tour_started",
            "run_limit_per_lead": 5,
            "params": {
                "time_offset_type": "after",
                "time_offset_unit": "hours",
                "time_offset_value": 2
            }
        },
        "message": "Hi {lead_first_name}, how did your tour go today? We would love to hear your thoughts on the property!"
    }
]
